<template>
    <v-error-boundary>
        <feathers-vuex-find service="api-lists" :query="{}" watch="query">
            <v-card slot-scope="{ items: desserts, isFindPending }">
                <v-card-title>
                    API Access Control
                    <v-spacer></v-spacer>
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
                </v-card-title>
                <v-data-table :headers="headers" :loading="isFindPending" :items="desserts" :search="search" loading-text="Fetching Data..." single-expand show-expand>
                    <template v-slot:item.id="{ item }">
                        <b>{{ item.id }}</b>
                    </template>
                    <template v-slot:item.roles="{ item }">
                        <v-chip x-small v-for="(access, index) in item.rules.access" class="ma-2" color="cyan" text-color="white" :key="index">{{ access }}</v-chip>
                        <v-chip x-small v-if="item.rules.access.length === 0" class="ma-2" color="red" text-color="white">Accessable to all</v-chip>
                    </template>
                    <template v-slot:expanded-item="{ headers, item }">
                        <td :colspan="headers.length">
                            <v-row>
                                <v-col align="end">
                                    <role-manager-dialog :key="`role-manager-${item.id}`" :item="item" @success="successMessage = true" @error="onError" />
                                </v-col>
                            </v-row>
                        </td>
                    </template>
                </v-data-table>
            </v-card>
        </feathers-vuex-find>
        <v-snackbar top v-model="successMessage" color="success">
            Successfully Saved!
        </v-snackbar>
        <v-snackbar top v-model="error.show" color="red">
            {{ error.message }}
        </v-snackbar>
    </v-error-boundary>
</template>

<script>
import RoleManagerDialog from './components/RoleManagerDialog';

export default {
    data() {
        return {
            search: '',
            headers: [
                {
                    text: 'Services',
                    align: 'start',
                    sortable: false,
                    value: 'id',
                },
                {
                    text: 'Target Roles',
                    align: 'end',
                    sortable: false,
                    value: 'roles'
                },
                {
                    text: 'Actions',
                    align: 'end',
                    value: 'data-table-expand'
                }
            ],
            successMessage: false,
            error: {
                show: false,
                message: ''
            },
            updateDialog: false,
            currentItem: {
                methods: [],
                rules: {
                    authenticate: [],
                    owner: false,
                    ownerField: 'user_id'
                },
                methodsItem() {
                    return { model: null };
                }
            },
            loadingForm: false
        }
    },
    errorCaptured(err,vm,info) {
        console.log(`cat EC: ${err.toString()}\ninfo: ${info}`); 
        return false;
    },
    methods: {
        // serviceMS(item) {
        //     return {
        //         get default() {
        //             return item.methods.indexOf('all') !== -1;
        //         },
        //         set default(value) {
        //             if(value) {
        //                 item.methods = ['all'];
        //             } else {
        //                 item.methods = [];
        //             }
        //         },
        //         get model() {
        //             return null;
        //         },
        //         set model(value) {

        //         }
        //     };
        // },
        serviceAS(item) {
            return {
                get default() {
                    return item.rules.authenticate.indexOf('all') !== -1;
                },
                set default(value) {
                    if(value) {
                        item.rules.authenticate = ['all'];
                    } else {
                        item.rules.authenticate = [];
                    }
                }
            };
        },
        async updateService(item) {
            try {
                this.loadingForm = true;
                await item.update();
                this.successMessage = true;
                item.dialog = false;
            } catch(err) {
                this.error.show = true;
                this.error.message = err.message;
            } finally {
                this.loadingForm = false;
            }
        },
        onError(err) {
            this.error.show = true;
            this.error.message = err.message;
        }
    },
    components: {
        RoleManagerDialog
    }
};
</script>